/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ScheduleSiteChangeRequestAssignmentDto } from './scheduleSiteChangeRequestAssignmentDto.schema';

export const ListOfScheduleSiteChangeRequestAssignmentDto = zod.array(zod.lazy(() => ScheduleSiteChangeRequestAssignmentDto));

export type ListOfScheduleSiteChangeRequestAssignmentDto = zod.input<typeof ListOfScheduleSiteChangeRequestAssignmentDto>;
export type ListOfScheduleSiteChangeRequestAssignmentDtoOutput = zod.output<typeof ListOfScheduleSiteChangeRequestAssignmentDto>;
